import {SmileyIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import React, {forwardRef} from 'react'

import {VALUES} from '../constants/values'
import styles from './ReactionViewerAnchor.module.css'

type RenderAnchorProps = React.HTMLAttributes<HTMLElement>
type ReactionViewerAnchorProps = {
  renderAnchorProps?: RenderAnchorProps
  reactionsAvailable?: boolean
}

export const ReactionViewerAnchor = forwardRef(
  ({renderAnchorProps, reactionsAvailable}: ReactionViewerAnchorProps, ref: React.ForwardedRef<HTMLButtonElement>) => {
    return (
      <IconButton
        size="small"
        icon={SmileyIcon}
        {...renderAnchorProps}
        aria-label={reactionsAvailable ? VALUES.react : VALUES.reactionsUnavailable}
        inactive={!reactionsAvailable}
        aria-labelledby={undefined}
        className={styles.ReactionViewerAnchorButton}
        ref={ref}
      />
    )
  },
)

ReactionViewerAnchor.displayName = 'ReactionViewerAnchor'
